<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش تخفیف ها</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span
            style="transform: translateY(3px)"
            class="feather-printer"
          ></span>
        </button>
        <!-- <ExcelDownload
          class="mr-2"
          url="admin/reports/varieties-list"
          :extraQuery="extraQuery"
        /> -->
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="chrome-off"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-6">
            <DatePickerRange
              :fromFormatType="'YYYY-MM-DD'"
              :toFormatType="'YYYY-MM-DD'"
              :fromType="'date'"
              :toType="'date'"
              :dfFType="'jYYYY-jMM-jDD'"
              :dfTType="'jYYYY-jMM-jDD'"
              v-model="filter.date"
            />
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
        <form autocomplete="off" class="mt-3 col-4">
          <b-form-group>
            <b-form-input v-model="filter.search" placeholder="جستجو" />
          </b-form-group>
        </form>
      </div>
      <div id="print" class="p-4">
        <div
          class="d-flex mb-3 mr-2-print"
          v-if="appliedFilter.date.startDate || appliedFilter.date.endDate"
        >
          <div v-if="appliedFilter.date.startDate">
            <span> از تاریخ</span
            ><span> {{ appliedFilter.date.startDate | persianDate }} </span>
          </div>
          <div class="mr-4" v-if="appliedFilter.date.endDate">
            <span> تا تاریخ</span
            ><span> {{ appliedFilter.date.endDate | persianDate }} </span>
          </div>
        </div>
        <div v-if="mainData" class="mr-3 ml-3 mt-5 mb-5 d-flex justify-content-between">
          <div>
            <strong class="fs-20">جمع کل بدون تخفیف:</strong>
            <span class="fs-18"
              >{{ mainData.total_without_discount | price }}تومان</span
            >
          </div>
          <div>
            <strong class="fs-20">جمع کل با تخفیف:</strong>
            <span class="fs-18"
              >{{ mainData.total_with_discount | price }}تومان</span
            >
          </div>
          <div>
            <strong class="fs-20"> مابه التفاوت:</strong>
            <span class="fs-18"
              >{{ mainData.total_difference | price }}تومان</span
            >
          </div>
        </div>
        <div class="w-100 mt-1 mb-2 mr-2-print" v-if="filter.search">
          جستجوی عبارت "{{ filter.search }}"
        </div>
        <b-table
          :total-rows="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          :filter="filter.search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-included-fields="['title', 'id']"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 + (page - 1) * perPage }}
          </template>
        </b-table>
        <b-pagination
          class="not-in-print"
          v-if="reports"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
        <div v-if="!reports" class="alert alert-primary">
          اطلاعاتی موجود نیست
        </div>
      </div>
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BPagination } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import { getVarietyTitle } from "@@/core/libraries/functions";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";

function Filter() {
  this.search = "";
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "ProductsReport",
  components: {
    ExcelDownload,
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    BPagination,
  },
  data() {
    return {
      disabled: false,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "p_id",
          label: "شناسه محصول",
          sortable: true,
        },
        {
          key: "title",
          label: "عنوان",
          sortable: true,
        },
        {
          key: "v_title",
          label: "عنوان تنوع",
          sortable: true,
        },
        {
          key: "quantity",
          label: "تعداد ",
          sortable: true,
        },
        {
          key: "price",
          label: "قیمت (تومان)",
          sortable: true,
        },
        {
          key: "discount",
          label: "تخفیف",
          sortable: true,
        },
      ],
      page: 1,
      perPage: 200,
      reports: null,
      mainData: null,
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      currentPage: 1,
    };
  },
  created() {
    // this.loadData();
  },
  computed: {
    extraQuery() {
      return {
        start_date: this.filter.date.startDate,
        end_date: this.filter.date.endDate,
      };
    },
    totalRows() {
      return this.reports ? this.reports.length : 0;
    },
  },
  methods: {
    print() {
      print();
    },
    doFilter() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          `admin/reports/report_discount/${this.appliedFilter.date.startDate}/${this.appliedFilter.date.endDate}`
        );
        this.mainData = response.data;
        this.reports = response.data.data;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
